import React from "react";
import PropTypes from "prop-types";
import { Col, Row, Spinner } from "react-bootstrap";
import { Button, Form } from "@dpdgroupuk/mydpd-ui";
import "./styles.scss";
import { ADDRESS_FIELDS } from "./constants";
const {
  MaterialTextInput,
  Group
} = Form;
const defaultValues = {
  organisation: "",
  property: "",
  street: "",
  locality: "",
  town: "",
  county: "",
  postcode: ""
};

const PostcodeFinderForm = ({
  onClear,
  onSubmit,
  onFocus,
  onBlur
}) => {
  const [submitting, setSubmitting] = React.useState(false);
  const [values, setValues] = React.useState(defaultValues);
  const [focusedField, setFocusedField] = React.useState();
  const handleChange = React.useCallback(fieldName => value => {
    const newValue = value.toUpperCase();
    setValues(prevValues => ({ ...prevValues,
      [fieldName]: newValue
    }));
  }, [setValues]);
  const handleFocus = React.useCallback(fieldName => () => {
    setFocusedField(fieldName);
    onFocus(fieldName);
  }, [setFocusedField, onFocus]);
  const handleBlur = React.useCallback(fieldName => () => {
    setFocusedField();
    onBlur(fieldName);
  }, [setFocusedField, onBlur]);
  const handleSubmit = React.useCallback(() => {
    setSubmitting(true);
    return onSubmit(values).finally(() => {
      setSubmitting(false);
    });
  }, [onSubmit, values, setSubmitting]);
  const onHandleKeyPress = React.useCallback(event => {
    if (event.key === "Enter") {
      if (!submitting) {
        handleSubmit();
      }
    }
  }, [handleSubmit, submitting]);
  const onClearPress = React.useCallback(() => {
    setValues(defaultValues);
    onClear();
  }, [onClear, setValues]);
  return /*#__PURE__*/React.createElement(Form, {
    className: "postcode-finder-form",
    noValidate: true
  }, /*#__PURE__*/React.createElement(MaterialTextInput, {
    label: "Organisation",
    name: ADDRESS_FIELDS.ORGANISATION,
    maxLength: 35,
    onKeyPress: onHandleKeyPress,
    onFocus: handleFocus(ADDRESS_FIELDS.ORGANISATION),
    onBlur: handleBlur(ADDRESS_FIELDS.ORGANISATION),
    value: values.organisation,
    onChange: handleChange(ADDRESS_FIELDS.ORGANISATION),
    meta: {
      active: focusedField === ADDRESS_FIELDS.ORGANISATION
    }
  }), /*#__PURE__*/React.createElement(MaterialTextInput, {
    label: "Property",
    name: ADDRESS_FIELDS.PROPERTY,
    maxLength: 35,
    onKeyPress: onHandleKeyPress,
    onFocus: handleFocus(ADDRESS_FIELDS.PROPERTY),
    onBlur: handleBlur(ADDRESS_FIELDS.PROPERTY),
    value: values.property,
    onChange: handleChange(ADDRESS_FIELDS.PROPERTY),
    meta: {
      active: focusedField === ADDRESS_FIELDS.PROPERTY
    }
  }), /*#__PURE__*/React.createElement(MaterialTextInput, {
    label: "Street",
    name: ADDRESS_FIELDS.STREET,
    minLength: 1,
    maxLength: 35,
    onKeyPress: onHandleKeyPress,
    onFocus: handleFocus(ADDRESS_FIELDS.STREET),
    onBlur: handleBlur(ADDRESS_FIELDS.STREET),
    value: values.street,
    onChange: handleChange(ADDRESS_FIELDS.STREET),
    meta: {
      active: focusedField === ADDRESS_FIELDS.STREET
    }
  }), /*#__PURE__*/React.createElement(MaterialTextInput, {
    label: "Locality",
    name: ADDRESS_FIELDS.LOCALITY,
    maxLength: 35,
    onKeyPress: onHandleKeyPress,
    onFocus: handleFocus(ADDRESS_FIELDS.LOCALITY),
    onBlur: handleBlur(ADDRESS_FIELDS.LOCALITY),
    value: values.locality,
    onChange: handleChange(ADDRESS_FIELDS.LOCALITY),
    meta: {
      active: focusedField === ADDRESS_FIELDS.LOCALITY
    }
  }), /*#__PURE__*/React.createElement(MaterialTextInput, {
    label: "Town",
    name: ADDRESS_FIELDS.TOWN,
    maxLength: 35,
    onKeyPress: onHandleKeyPress,
    onFocus: handleFocus(ADDRESS_FIELDS.TOWN),
    onBlur: handleBlur(ADDRESS_FIELDS.TOWN),
    value: values.town,
    onChange: handleChange(ADDRESS_FIELDS.TOWN),
    meta: {
      active: focusedField === ADDRESS_FIELDS.TOWN
    }
  }), /*#__PURE__*/React.createElement(MaterialTextInput, {
    label: "County",
    name: ADDRESS_FIELDS.COUNTY,
    maxLength: 35,
    onKeyPress: onHandleKeyPress,
    onFocus: handleFocus(ADDRESS_FIELDS.COUNTY),
    onBlur: handleBlur(ADDRESS_FIELDS.COUNTY),
    value: values.county,
    onChange: handleChange(ADDRESS_FIELDS.COUNTY),
    meta: {
      active: focusedField === ADDRESS_FIELDS.COUNTY
    }
  }), /*#__PURE__*/React.createElement(MaterialTextInput, {
    label: "Postcode",
    name: ADDRESS_FIELDS.POSTCODE,
    maxLength: 8,
    onKeyPress: onHandleKeyPress,
    onFocus: handleFocus(ADDRESS_FIELDS.POSTCODE),
    onBlur: handleBlur(ADDRESS_FIELDS.POSTCODE),
    value: values.postcode,
    onChange: handleChange(ADDRESS_FIELDS.POSTCODE),
    meta: {
      active: focusedField === ADDRESS_FIELDS.POSTCODE
    }
  }), /*#__PURE__*/React.createElement(Group, {
    bsPrefix: "mb-3",
    as: Row
  }, /*#__PURE__*/React.createElement(Col, {
    className: "d-flex justify-content-between",
    sm: {
      span: 8,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "dark",
    onClick: onClearPress,
    className: "clear-button"
  }, "Clear"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "find-button",
    onClick: handleSubmit,
    disabled: submitting
  }, submitting ? "Finding..." : "Find Address", submitting && /*#__PURE__*/React.createElement(Spinner, {
    as: "span",
    animation: "border",
    size: "sm",
    role: "status",
    "aria-hidden": "true"
  })))));
};

PostcodeFinderForm.propTypes = {
  onClear: PropTypes.func,
  onSubmit: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};
PostcodeFinderForm.defaultProps = {
  onFocus: () => {},
  onBlur: () => {}
};
export default PostcodeFinderForm;